import React from "react";
import { useLang } from "@/context/LanguageContext";
import { PawIcon } from "@/components/Icons";
import Reveal from "@/components/Reveal";

const images = [
  "/images/gallery-1.jpg",
  "/images/gallery-2.jpg",
  "/images/gallery-3.jpg",
  "/images/gallery-4.jpg",
  "/images/gallery-5.jpg",
  "/images/gallery-6.jpg",
  "/images/gallery-7.jpg",
  "/images/gallery-8.jpg",
  "/images/gallery-9.jpg",
  "/images/gallery-10.jpg",
  "/images/gallery-11.jpg",
];

const Gallery = () => {
  const { t } = useLang();
  return (
    <section id="gallery" className="py-20 sm:py-28 section-soft" data-testid="gallery-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal className="text-center max-w-2xl mx-auto mb-12">
          <span className="font-script text-3xl text-[#f4956a] inline-flex items-center gap-2">
            <PawIcon size={22} /> Galerie
          </span>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl mt-2">{t.gallery.title}</h2>
          <p className="text-[#6b3f2a]/75 mt-4 text-sm sm:text-base">{t.gallery.subtitle}</p>
        </Reveal>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-5">
          {images.map((src, i) => (
            <Reveal key={i} delay={Math.min(i * 50, 400)} className="gallery-item aspect-square">
              <img
                src={src}
                alt={`Carol Tierbetreuung ${i + 1}`}
                loading="lazy"
                data-testid={`gallery-img-${i}`}
              />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
